<!-- 无数据提示组件 -->
<template>
  <div @click="onClickLayout()" class="noData" :style="{'height': height}">
    <img v-if="isShowImage" src="../assets/public/icon_no_data2.svg" />
    <div>{{text?text:$t("common.noDataHint")}}</div>
  </div>
</template>

<script>

  export default {
    name: 'view-noData',
    props: {
      text: {
        type: String,
        default: ""
      },
      isShowImage: {
        type: Boolean,
        default: true
      },
      height: {
        type: String,
        default: "280px"
      }
    },
    data() {
      return {}
    },
    methods: {
      onClickLayout() {
        this.$emit("onClick");
      }
    }
  }
</script>

<style scoped>
  .noData {
    width: 100%;
    display: flex;
    flex-direction: column;
    color: #7a8899;
    font-size: 1.4rem;
    line-height: 3rem;
    align-items: center;
    justify-content: center;
  }
</style>



// WEBPACK FOOTER //
// src/components/view-noData.vue